{
  "en": {
    "baseChip": {
      "states": {
        "included": "included",
        "excluded": "excluded"
      },
      "sortHint": "Use the arrow keys to move"
    }
  }
}
